// extracted by mini-css-extract-plugin
module.exports = {"languageAndCurrency":"style_languageAndCurrency__ozKvH","icon":"style_icon__NWPLn","languageAndCurrencySideModalH":"style_languageAndCurrencySideModalH__wM9hs"};